"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var colorVariations_1 = __importDefault(require("./colorVariations"));
exports.default = (function (props) {
    var color = (0, colorVariations_1.default)(props);
    return color && "color: " + color + ";";
});
